import React from 'react';
export function SolutionSection() {
  return <section className="bg-gradient-to-b from-dark-900 via-[#141000] to-[#1a1500] py-[80px] px-5 text-center" data-id="element-437" data-mp="324booh7b1n7j">
      <div className="max-w-[1100px] mx-auto" data-id="element-438" data-mp="3abvq1t9hge1d">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-alphaGold" data-id="element-439" data-mp="3o9k8kug2v939">
          La Solución Ya Existe —<br data-id="element-440" data-mp="3j8w8lj9vfhww" />Y Está en AlphaFit
        </h2>

        <div className="max-w-[800px] mx-auto text-[1.1rem] leading-[1.9] text-[#ccc] mt-8" data-id="element-441" data-mp="142rxhpax502">
          <p data-id="element-442" data-mp="3t8n33kyflwwz">
            No necesitás gastar fortunas en marcas importadas ni esperar semanas
            para que llegue tu pedido.
            <strong className="text-white" data-id="element-443" data-mp="at2tn8v6uehy"> Cibeles y Profit</strong> son las
            marcas de suplementos de calidad certificada disponibles ahora
            mismo, en tu ciudad, a precios que tienen sentido.
          </p>
        </div>

        <div className="bg-alphaGold/10 border border-alphaGold/30 rounded-md p-[30px] my-[40px] mx-auto max-w-[700px] text-[1.2rem] font-bold text-white leading-[1.6]" data-id="element-444" data-mp="kq7glawuydzt">
          "Con la suplementación correcta, tu cuerpo tiene todo lo que necesita
          para crecer, recuperarse y rendir al máximo — entrenamiento tras
          entrenamiento."
        </div>

        <div className="max-w-[800px] mx-auto text-[1.1rem] leading-[1.9] text-[#ccc]" data-id="element-445" data-mp="3f9qyqhosk7au">
          <p data-id="element-446" data-mp="3kb6kkbysmhua">
            En <strong className="text-white" data-id="element-447" data-mp="3kbopdwziu4dt">AlphaFit</strong> creemos en la
            calidad sin excusas. Cada producto está formulado para resultados
            reales — no promesas vacías. Y hoy, con{' '}
            <strong className="text-white" data-id="element-448" data-mp="3u6glsxhdal70">20% OFF</strong>, no hay razón para
            esperar.
          </p>
        </div>
      </div>
    </section>;
}